import { ExternalReferenceSummary } from 'queries/cases/types';

export const getTotalExternalReferences = (summary: ExternalReferenceSummary): number => {
  return Object.values(summary).reduce((acc, value) => acc + value, 0);
};
